module.exports = __webpack_public_path__ + "static/media/facture_color.d99ce02b.svg";